import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var SynchronizeOutlineIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { d: "M8.94 4.61c-.97.403-1.85.995-2.589 1.741L9 9H3V3l1.938 1.938A9.928 9.928 0 0112 2c5.514 0 10 4.485 10 10h-2c0-4.411-3.589-8-8-8a7.939 7.939 0 00-3.06.61zM15.06 19.39a7.936 7.936 0 002.589-1.741L15 15h6v6l-1.937-1.938A9.93 9.93 0 0112 22C6.486 22 2 17.515 2 12h2c0 4.411 3.589 8 8 8a7.937 7.937 0 003.06-.61z", fill: "currentColor" })] })));
};

export { SynchronizeOutlineIcon };
//# sourceMappingURL=SynchronizeOutlineIcon.js.map
